var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBordered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "checkBordered_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 13,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v13H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.68 1.32a1.09 1.09 0 00-1.541 0L5.687 8.77 2.861 5.945a1.09 1.09 0 10-1.542 1.542l3.598 3.597a1.09 1.09 0 001.548-.007l8.216-8.216a1.09 1.09 0 000-1.541z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.68 1.32a1.09 1.09 0 00-1.541 0L5.687 8.77 2.861 5.945a1.09 1.09 0 10-1.542 1.542l3.598 3.597a1.09 1.09 0 001.548-.007l8.216-8.216a1.09 1.09 0 000-1.541z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.139 1.32l-.707-.707.707.707zm1.542 0l-.707.707.707-.707zM5.687 8.77l-.707.707.707.708.708-.708-.708-.707zM2.861 5.945l-.707.707.707-.707zM1.319 7.487l-.707.707.707-.707zm3.598 3.597l.707-.707-.707.707zm1.548-.007l-.707-.707-.006.006.713.701zm8.216-8.216l-.707-.707.707.707zm-.835-.834a.09.09 0 01.128 0L15.388.613a2.09 2.09 0 00-2.956 0l1.414 1.414zM6.395 9.478l7.451-7.451L12.432.613 4.98 8.064l1.415 1.414zM2.154 6.652L4.98 9.478l1.415-1.414-2.827-2.826-1.414 1.414zm-.128 0a.09.09 0 01.128 0l1.414-1.414a2.09 2.09 0 00-2.956 0l1.414 1.414zm0 .128a.09.09 0 010-.128L.612 5.238a2.09 2.09 0 000 2.956L2.026 6.78zm3.598 3.597L2.026 6.78.612 8.194 4.21 11.79l1.415-1.414zm.127 0a.09.09 0 01-.127 0L4.209 11.79a2.09 2.09 0 002.956 0l-1.414-1.414zm0 0l1.414 1.414.013-.013-1.426-1.402zm8.223-8.223L5.758 10.37l1.414 1.414 8.216-8.215-1.414-1.415zm0-.127a.09.09 0 010 .127l1.414 1.415a2.09 2.09 0 000-2.956l-1.414 1.414z",
    fill: "#fff",
    mask: "url(#checkBordered_svg__a)"
  })));
}
export default SvgCheckBordered;